exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "h3[data-v-41e0adf9]{width:100%;margin-top:0;text-transform:capitalize}.badgeGutter[data-v-41e0adf9]{padding-left:8px;padding-right:8px}.badgeGutter[data-v-41e0adf9]:nth-of-type(3n+1){padding-left:0!important}.badgeGutter[data-v-41e0adf9]:nth-of-type(3n){padding-right:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-41e0adf9","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/util/CollectedBadges.vue
// module id = 427
// module chunks = 0